module.exports = __webpack_public_path__ + "img/P150T_weapon_64.d85d0c4a.png";